module.exports = __webpack_public_path__ + "assets/img/fdee42ccecd745d19860d8a842d356e8.svg";